import {
  Body,
  Button,
  type DeeplyNestedSx,
  Heading,
  Stack,
} from "@biom3/react";
import { merge } from "ts-deepmerge";

const translations: Record<string, string> = {
  creating_wallet_title: "Creating your wallet...",
  creating_wallet_caption: "Hang tight",
  balances_empty_title_variation_a: "So many games,\nso little funds",
  balances_empty_caption_variation_a:
    "You never know when the next gaming gold rush will hit. Be ready",
  balances_empty_primary_button_a: "Add tokens",
  balances_empty_secondary_button_a: "Learn more",
  inventory_empty_title_variation_b: "Nothing here!\nLet's change that",
  inventory_empty_caption_variation_b:
    "Explore true ownership of your favourite game items",
  inventory_empty_primary_button_b: "Browse collections",
  inventory_empty_secondary_button_b: "Bring them from another wallet",
  wallets_empty_title_variation_a: "Got collectables?\nUse them in game",
  wallets_empty_caption_variation_a:
    "Link a wallet (EOA or hardware) to use your collectables in game",
  wallets_empty_primary_button_a: "Select a wallet to get started",
  wallets_empty_secondary_button_a: "Learn more",
};

export const BaseEmptyState = ({
  creatingWallet,
  titleKey,
  captionKey,
  primaryButtonKey,
  secondaryButtonKey,
  primaryButtonClick,
  primaryMouseOver,
  secondaryButtonClick,
  sx = {},
}: {
  creatingWallet: boolean;
  titleKey: string;
  captionKey: string;
  primaryButtonKey: string;
  secondaryButtonKey: string;
  primaryButtonClick: () => void;
  primaryMouseOver: (hovering: boolean) => void;
  secondaryButtonClick: () => void;
  sx?: DeeplyNestedSx;
}) => {
  const t = (key: string) => translations[key] || key;
  return (
    <Stack sx={merge({ maxw: "430px", mt: "base.spacing.x8" }, sx)}>
      <Heading
        testId="EmptyStateView-Title"
        sx={{
          px: "base.spacing.x2",
          textAlign: "center",
          mb: "base.spacing.x3",
          whiteSpace: "pre-line",
        }}
      >
        {t(creatingWallet ? "creating_wallet_title" : titleKey)}
      </Heading>
      <Body
        testId="EmptyStateView-Title"
        size={"medium"}
        weight={"bold"}
        sx={{
          px: "base.spacing.x2",
          color: "base.color.text.body.secondary",
          minh: "112px",
          textAlign: "center",
        }}
      >
        {t(creatingWallet ? "creating_wallet_caption" : captionKey)}
      </Body>
      {!creatingWallet && (
        <>
          <Button
            testId="EmptyStateView-PrimaryButton"
            size="large"
            variant="primary"
            onClick={primaryButtonClick}
            onMouseEnter={() => primaryMouseOver(true)}
            onMouseLeave={() => primaryMouseOver(false)}
          >
            {t(primaryButtonKey)}
          </Button>
          <Button
            testId="EmptyStateView-SecondaryButton"
            size="large"
            variant="tertiary"
            onClick={secondaryButtonClick}
          >
            {t(secondaryButtonKey)}
          </Button>
        </>
      )}
    </Stack>
  );
};
